<template>
    <div class="home">
      <div class="bodder-div">
        <div class="top-div">
          <div class="title-div">深圳市启帆云游科技有限公司</div>
          <div class="content-div">
            <div class="title-text-div">
              <div class="title-text-two">深圳市启帆云游科技有限公司主要经营范围包括技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；计算机软硬件及辅助设备零售；平面设计；互联网销售（除销售需要许可的商品）；软件开发；人工智能基础软件开发；大数据服务。</div>
              <!-- <div class="download-show-div">
                <div class="download-div" @click="downMethod">
                  <el-image
                    style="width: 20px; height: 20px"
                    :src="require('@/assets/icon_andrio.png')"
                    fit="cover"
                  />
                  <span class="download-title">安卓下载</span>
                </div>
                <div class="download-div download-left" @click="downMethod">
                  <el-image
                    style="width: 20px; height: 20px"
                    :src="require('@/assets/icon_ios.png')"
                    fit="cover"
                  />
                  <span class="download-title">苹果下载</span>
                </div>
              </div> -->
            </div>
            <el-image
                style="width: 500px;"
                :src="require('@/assets/company_logo.png')"
                fit="contain"
              />
         
          </div>
        </div>
        <div class="image-show-div">
          <el-image
          style="width: 300px; border: 0.1px solid #ff6f6f;"
            fit="cover"
            :src="require('@/assets/jiufang_01.png')"
          />
          <el-image
          style="width: 300px; border: 0.5px solid #ff6f6f;"
            fit="cover"
            class="left"
            :src="require('@/assets/jiufang_02.png')"
          />
          <el-image
          style="width: 300px; border: 0.5px solid #ff6f6f;"
            fit="cover"
            class="left"
            :src="require('@/assets/jiufang_03.png')"
          />
          <el-image
            style="width: 300px; border: 0.5px solid #ff6f6f;"
            fit="cover"
            class="left"
            :src="require('@/assets/jiufang_04.png')"
          />
        </div>
     
      </div>

      <div class="bottom-div">
          <div>公司名称：深圳市启帆云游科技有限公司</div>
            <div>公司地址：深圳市南山区粤海街道科技园社区科苑路8号讯美科技广场3号楼15327</div>
            <!-- <div @click="open">ICP备案证书号：粤ICP备2023100077号-1</div> -->

            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">ICP备案证书号：粤ICP备2026135110号</a>


            <div>邮箱：lsx9264@163.com</div>
        </div>
    </div>
  </template>
  
  <script>
  import { ElMessage } from "element-plus";
  
  export default {
    name: "jiufangdianjing",
    components: {},
  
    setup() {
      function downMethod() {
        ElMessage({
          showClose: true,
          message: "待上架，敬请期待",
          type: "success",
        });
      }

      function open(){


      }
  
      function anDownMethod(){
        const openUrl = `https://api.hhaohao.com/app/download`;
        var a = document.createElement("a"); // 创建一个<a></a>标签
        a.href = openUrl;
        a.download = "KeXingRen.apk"; // 设置下载文件文件名
        a.style.display = "none"; // 隐藏a标签
        document.body.appendChild(a); // 将a标签追加到文档对象中
        a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
        a.remove(); // 一次性的，用完就删除a标签
      }
  
      return { downMethod ,anDownMethod,open};
    },
  };
  </script>
  
  <style scoped>
  .home {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #FFE417;
  }
  
  .bodder-div {
    /* margin-top: 20px; */
    width: 90%;
    height: 100%;
    background-color: white;
    background-color: #FFE417;
  }
  .top-div {
    /*  */
    overflow: hidden;
  }
  .title-div {
    margin-left: 0px;
    width: 400px;
    height: 73px;
    background-color: #fef2ee;
    border-radius: 0px 0px 8px 8px;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-family: Alibaba PuHuiTi 2-85 Bold, Alibaba PuHuiTi 20;
    font-weight: normal;
    color: #000000;
    line-height: 28px;
  }
  .content-div {
    display: flex;
    margin-top: 90px;
    padding-left: 200px;
  }
  .title-text-div {
    margin-left: 96px;
    text-align: left;
    padding-top: 12px;
  }
  .title-text {
    font-size: 72px;
    font-family: Alibaba PuHuiTi 2-95 ExtraBold, Alibaba PuHuiTi 20;
    font-weight: normal;
    color: #ffffff;
    line-height: 84px;
  }
  .title-text-two {
    font-size: 40px;
    font-family: Alibaba PuHuiTi 2-95 ExtraBold, Alibaba PuHuiTi 20;
    font-weight: normal;
    color: #1a1a1a;
    line-height: 60px;
    margin-top: 10px;
    max-width: 1000px;
  }
  .image-show-div {
    display: flex;
    padding-top: 87px;
    align-items: center;
    justify-content: center;
    padding-bottom: 60px;
  }
  .left {
    margin-left: 100px;
  }
  .bottom-div {
    background-color: #f8f8f8;
    height: 130px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC-常规体, PingFang SC;
    font-weight: normal;
    color: #1a1a1a;
    line-height: 28px;
    width: 100%;
  }
  .download-div {
    display: flex;
    background-color: #fef2ee;
    align-items: center;
    width: 120px;
    height: 40px;
    margin-top: 10px;
    justify-content: center;
    border-radius: 4px 4px 4px 4px;
    cursor: pointer;
  }
  .download-title {
    margin-left: 4px;
    font-size: 14px;
    font-family: PingFang SC-常规体, PingFang SC;
    font-weight: normal;
    color: #1a1a1a;
    line-height: 28px;
  }
  .download-left {
    margin-left: 20px;
  }
  .download-show-div {
    display: flex;
    padding-left: 6px;
    margin-top: 20px;
  }
  </style>
  